{
  "collapse": "Zbaliť",
  "expand": "Rozbaliť"
}
